// extracted by mini-css-extract-plugin
export var changeIcon = "_5s-4";
export var container = "_5s-0";
export var divider = "_5s-7";
export var externalLinkIcon = "_5s-1";
export var green = "_5s-5";
export var helpCircleIcon = "_5s-3";
export var iconButton = "_5s-2";
export var red = "_5s-6";